import {
    QuickSightState,
    FetchState,
    QuickSightUserReportList,
    QuickSightUserReportsApiResponse
} from "@/shared/types";
import * as storeHelper from "@/shared/storeHelper";
import { embedDashboard } from "amazon-quicksight-embedding-sdk";
import * as userService from "@/shared/api/userService";
import moment from "moment";
import { AxiosResponse } from "axios";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: QuickSightState = {
    fetchState: FetchState.Uninitialized,
    userReportsFetchState: FetchState.Uninitialized,
    userReports: {}
};
const embed = options => {
    const defaultOpts = {
        height: "AutoFit",
        scrolling: "no",
        locale: "en-US"
    };

    const embedOptions = { ...defaultOpts, ...options };
    return embedDashboard(embedOptions);
};

export const useQuicksightStore = defineStore("quicksight", {
    state: (): QuickSightState => (_.cloneDeep(initialState)),
    actions: {
        setFetchState (newFetchState: FetchState) {
            this.fetchState = newFetchState;
        },
        setUserReportsFetchState (fetchState: FetchState) {
            this.userReportsFetchState = fetchState;
        },
        setUserReports (userReports: QuickSightUserReportList) {
            this.userReports = userReports;
        },
        getUserReports (userParams: { employerId: number, partnerId: number }): Promise<void> {
            if (this.userReportsFetchState === FetchState.Loading) {
                return;
            }

            this.setUserReportsFetchState(FetchState.Loading);
            let serviceCall: Promise<AxiosResponse<QuickSightUserReportsApiResponse>> = null;
            if (userParams.employerId) {
                serviceCall = userService.getEmployerQuickSightReports(userParams.employerId);
            } else {
                serviceCall = userService.getPartnerQuickSightReports(userParams.partnerId);
            }

            return serviceCall.then(resp => {
                this.setUserReportsFetchState(FetchState.Loaded);
                this.setUserReports(resp.data.reportsByCategory);
            }).catch(err => {
                return storeHelper.handleError({ error: err, rethrow: true });
            });
        },
        embed (
            { elem, id, parameters }: { elem: any, id: string, parameters: { [k: string]: string | number } }
        ): Promise<void> {

            if (!parameters.PartnerId && !parameters.EmployerId) {
                // tslint:disable-next-line:no-console
                console.error("PartnerId or EmployerId parameter is required for report embed"); // eslint-disable-line
                return;
            }

            this.setFetchState(FetchState.Loading);

            const loadCallback = () => {
                this.setFetchState(FetchState.Loaded);
            };

            const errorCallback = () => {
                storeHelper.handleError({ error: "Failed to load report", rethrow: false });
                this.setFetchState(FetchState.Uninitialized);
            };

            return userService.generateEmbed(id)
                .then(resp => {
                    setTimeout(loadCallback, 4000); // provide some time for the iframe to initialize
                    const dashboard = embed({
                        container: elem,
                        url: resp.data.EmbedUrl,
                        // note, quicksight parameters are CaSe SenSiTivE!
                        parameters: {
                            Year: moment().year(),
                            ...parameters
                        },
                        loadCallback,
                        errorCallback
                    });

                    return dashboard;
                });
        },
    }
});
